export function stopScroll(){
  var mo=function(e){e.preventDefault();};
  document.body.style.overflow='hidden';
  document.addEventListener("touchmove",mo,false);
}

export function startScroll(){
  var mo=function(e){e.preventDefault();};
  document.body.style.overflow='';
  document.removeEventListener("touchmove",mo,false);
}
